import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 996,
	height: 109,
	fill: "none",
	viewBox: "0 0 996 109",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M275 68.5C192.7 65.5 5-16.2-70.3 3c-31.7 8 59.5 105.5 59.5 105.5h1006S745.7 92.1 693.7 88.2c-82-6.2-128.5 13.9-211 10-83.4-3.7-124.2-26.5-207.7-29.7Z"
	})
});
const SvgSnowFront = styled(base)({});
export default SvgSnowFront;
